import React, {useState} from 'react';
import PropTypes from 'prop-types';
import UserInfoService from "services/AccountInfo/";
import Day from 'dayjs';
import StorageService from 'services/StorageService';
import Link  from 'components/Link';
import Loader from 'components/Loader';
import style from './style.scss'; //NOSONAR

const TermsAndConditions = ({close}) => {
    const [checked, setChecked] = useState(true);
    const [isLoading, setLoading] = useState(false);

    const onChange = (event) => {
        if(event.target.checked) {
            setChecked(true);
        } else {
            setChecked(false);
        }
        
    }

    const click = () => {
        
        let terms = {
            terms_acceptance_date: Day().format()
        };

        if(checked) {
            setLoading(true);
            UserInfoService.updateUser(terms).then(() => {
                let data = StorageService.getSecureItem('userData');
                data.terms_acceptance_date = terms.terms_acceptance_date;
                StorageService.setSecureItem('userData', data);
                setLoading(false);
                setTimeout(() => {
                    close();
                }, 500);
            })
        }
    }

    return (
        <div className='new-modal-container terms-and-conditions'>
            <div className={'new-modal-scroll'}>
                <h1 className="new-modal-title">Cambio en Términos y Condiciones</h1>
                <h3 className="terms-and-conditions-subtitle">Cargos en Tarjeta de Crédito</h3>
                <p className="terms-and-conditions-paragraph">Cuando el cliente ingresa un pedido en Jumbo.cl, en su tarjeta de crédito verá una primera transacción correspondiente al cobro por el monto del pedido ingresado. Al finalizar la preparación del pedido, el cliente será contactado por la persona encargada de preparar su pedido, para revisar la sustitución de los productos que no estuvieran disponibles y le comunicará las diferencias de precio asociadas a los reemplazos. Una vez aceptados los cambios por parte del cliente, se generará un nuevo movimiento en su tarjeta, correspondiente esta vez a las devoluciones o cobro de las diferencias.</p>
                <p className="terms-and-conditions-paragraph last-paragraph-terms">Para los productos a granel, se considerará la notificación telefónica en detalle sólo cuando las diferencias estén bajo o sobre el 10% del peso solicitado por el cliente. Si las diferencias estuvieran dentro del 10% del peso solicitado, siempre se cobrará la cantidad real correspondiente al peso del producto entregado.</p>
            </div>
            <div className="modal-actions">
                <label className="terms-and-conditions-cont-check">
                    <input type="checkbox" name='terms-and-conditions' checked={checked} onChange={(event) => onChange(event)}/>    
                    <span className="terms-and-conditions-accept">Acepto los nuevos los <Link target={"_blank"} to="/institucional/terminos-condiciones" className="terms-and-conditions-link">Términos y condiciones</Link></span>
                </label>
                
                <button className={checked ? "primary-btn" : "disabled-btn"} onClick={click}>
                    {!isLoading && 'Confirmar'}
                    {isLoading && <span className="terms-and-conditions-loader"><Loader/></span>}
                </button>
            </div>
        </div>
    )
}

TermsAndConditions.propTypes = {
    close: PropTypes.func
}

export default TermsAndConditions;
